import React, { useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core";
import { useIntl } from "react-intl";
import axios from "axios";
import SelectAutoComplete from "./SelectAutoComplete";
import { maybeCallback } from "../_common/utils/fp";
import { createSnackbar } from "../_common";

function SelectCidade({
  value,
  onChange,
  field,
  form,
  estado,
  disabled,
  onLoadData,
  validate,
  showLoader = false,
  ...props
}) {
  const firstRender = useRef(false);
  const [isLoading, setIsLoading] = useState(false);
  const change = field ? v => form.setFieldValue(field.name, v) : v => onChange(v);
  const [cidades, setCidades] = useState([]);
  const intl = useIntl();

  async function fetchCidades() {
    try {
      setIsLoading(true);
      const { data } = await axios.get(`/api/pipeline/cidade/listar?estadoid=${estado}`);
      setCidades(data);
      maybeCallback(onLoadData)(data);
    } catch (err) {
      createSnackbar("Erro ao buscar cidades.");
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(
    () => {
      if (!firstRender.current) firstRender.current = true;
      else change({});
      if (!estado) setCidades([]);
      else fetchCidades();
    },
    [estado]
  );

  useEffect(
    () => {
      maybeCallback(onLoadData)(cidades);
    },
    [cidades]
  );

  return (
    <SelectAutoComplete
      label={intl.formatMessage({ defaultMessage: "Cidade" })}
      placeholder={intl.formatMessage({ defaultMessage: "Digite para filtrar" })}
      options={cidades}
      value={field ? field.value : value}
      onChange={nome =>
        change(nome ? { id: cidades.find(({ descricao }) => descricao === nome).id, descricao: nome } : {})
      }
      disabled={!cidades.length || disabled}
      size={10}
      isLoading={showLoader || isLoading}
      {...props}
    />
  );
}

SelectCidade.propTypes = {
  value: PropTypes.shape({
    id: PropTypes.number,
    descricao: PropTypes.string,
  }),
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  estado: PropTypes.number,
  field: PropTypes.object,
  form: PropTypes.object,
  onLoadData: PropTypes.func,
  showLoader: PropTypes.bool,
  validate: PropTypes.func,
};

export default withStyles({})(SelectCidade);
